export default __webpack_public_path__ + "assets/icon-collections.bb4ae764.webp";